import React from 'react';
import { styles, cx } from '../styles';
import { useThemeClasses } from '../providers/ThemeProvider';

interface ScreenshotPlaceholderProps {
  title: string;
  description: string;
  url?: string;
  filename?: string;
  className?: string;
}

const ScreenshotPlaceholder: React.FC<ScreenshotPlaceholderProps> = ({ 
  title, 
  description, 
  url, 
  filename,
  className = ""
}) => {
  const themeClasses = useThemeClasses();
  
  return (
    <div className={cx(styles.screenshot.container, themeClasses.bgSurface, themeClasses.borderPrimary, 'border', className)}>
      <div className={cx(styles.screenshot.header, themeClasses.bgSecondary, themeClasses.textSecondary, themeClasses.borderSecondary, 'border-b')}>
        {title}
      </div>
      <div className={styles.screenshot.content}>
        {filename ? (
          // If we have a filename, try to load the actual image
          <img 
            src={`/images/help/${filename}`}
            alt={description}
            className={styles.screenshot.image}
            onError={(e) => {
              // Fallback to placeholder if image doesn't exist
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.classList.remove('hidden');
            }}
          />
        ) : null}
        <div className={filename ? 'hidden' : ''}>
          <div className={cx(styles.screenshot.placeholder.container, themeClasses.bgSecondary, themeClasses.borderSecondary, 'border-2 border-dashed')}>
            <div className={cx(styles.screenshot.placeholder.icon, themeClasses.textSecondary)}>📸</div>
            <div className={cx(styles.screenshot.placeholder.text, themeClasses.textSecondary)}>
              {url ? `Screenshot: ${url}` : 'Screenshot wird hier eingefügt'}
            </div>
          </div>
          <p className={cx(styles.screenshot.description, themeClasses.textSecondary)}>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ScreenshotPlaceholder;
